showRandomBanner();

function showRandomBanner() {
  const banners = [".banner", ".bannerv2"];
  const randomIdx = Math.floor(Math.random() * banners.length);
  const selectedBanner = document.querySelector(banners[randomIdx]);
  if (!selectedBanner) {
    return;
  }
  selectedBanner.classList.add('visible');
  closeHandler(selectedBanner);
}

function closeHandler(banner) {
  const closeIcon = document.querySelectorAll(".close__banner");
  const imagePlayer = document.querySelector(".banner__player");
  const imageRocket = document.querySelector(".bannerv2__rocket");
  closeIcon.forEach((icon) =>
    icon.addEventListener("click", () => {
      banner.classList.add("hide");
      imagePlayer.classList.add("hide");
      imageRocket.classList.add("hide");
    })
  );
}
